(function(angular) {
    'use strict';

    angular
        .module('repairforms.config.module', ['ngRoute', 'ui.router', 'pascalprecht.translate', 'ngSanitize', 'repairforms.constant.module', 'repairforms.data.module']);
    angular
        .module('repairforms.constant.module', []);
    angular
        .module('repairforms.factory.module', []);
    angular
        .module('repairforms.controller.module', ['ui.bootstrap', 'ui.select', 'ngSanitize', 'xeditable', 'ngMaterial']);
    angular
        .module('repairforms.filter.module', []);
    angular
        .module('repairforms.service.module', ['ng.deviceDetector']);
    angular
        .module('repairforms.modal.module', []);
    angular
        .module('repairforms.directive.module', []);
    angular
        .module('repairforms.data.module', []);



})(angular);